module.exports = __webpack_public_path__ + "img/type--4-spans--multiple-lang--en.d85e17fd.jpg";